(function () {
    'use strict';
    const config = document.getElementById('cd-config');
    if (!config) return;
    const cfg = JSON.parse(config.textContent), root = (cfg.root || '/').replace(/\/?$/, '/');
    const ids = new Set(cfg.variants.map(v => String(v.id)));
    let checking = false;
    const count = cart => (cart.items || []).reduce((n, item) => n +
        (String(item.product_id) === String(cfg.productId) || ids.has(String(item.variant_id || item.id)) ? item.quantity : 0), 0);
    async function checkout(onError) {
        if (checking) return;
        checking = true;
        try {
            const response = await fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Bag unavailable');
            const cart = await response.json();
            if (!Array.isArray(cart.items)) throw new Error('Bag unavailable');
            if (!cart.items.length || count(cart) === 1) window.location.assign(root + 'pages/colours');
            else window.location.assign(root + 'checkout');
        } catch (_) {
            onError?.('We could not check your bag. Please try again.');
        } finally { checking = false; }
    }
    window.CottonSalwarCartRules = { count, checkout };
    document.addEventListener('submit', event => {
        if (!event.target.matches('[data-salwar-cart]')) return;
        event.preventDefault();
        const button = event.target.querySelector('[name="checkout"]'), status = document.getElementById('cartStatus');
        if (!button || button.disabled) return;
        button.disabled = true;
        checkout(message => { status.textContent = message; }).finally(() => { button.disabled = false; });
    });
}());
